(function (module) {
    'use strict';

    function ViewUserInAccountCtrl($stateParams, User, Store, Includes) {
        this.$onInit = () => {
            this.userId = $stateParams.userId;
            this.accountId = $stateParams.accountId;
            User
                .findById({ id: this.userId, filter: Includes.users })
                .$promise
                .then((response) => {
                    this.user = response;
                });
        };
        this.saveUser = () => {
            User
                .prototype$patchAttributes(
                    { id: this.user.id },
                    {
                        firstName: this.user.firstName,
                        lastName: this.user.lastName,
                        email: this.user.email.toLowerCase(),
                        emailVerified: this.user.emailVerified,
                        enabled: this.user.enabled,
                    },
                )
                .$promise
                .then(() => {
                    this.form.$setPristine();
                })
                .catch((error) => {
                    console.error(error);
                    Raven.captureException(error);
                });

        };
        this.sendResetPasswordLink = () => {
            this.api = {
                message: '',
            };
            User
                .forgotPassword({ email: this.user.email.toLowerCase() }).$promise
                .then((response) => {
                    this.api.message = 'Email has been sent';
                })
                .catch((error) => {

                    this.api.message = error.data.error.message;

                });

        };
    }

    module
        .component('viewUserInAccountComponent', {
            templateUrl: '/js/admin/accounts/view-account/view-user-in-account/view-user-in-account.html',
            controller: ViewUserInAccountCtrl,
        })
        .config(function ($stateProvider) {
            $stateProvider
                .state('root.admin.accounts.view.user', {
                    url: '/:userId',
                    data: {
                        pageTitle: 'ADMIN_ACCOUNTS_VIEW.USER.PAGE_TITLE',
                    },
                    views: {
                        'content@root': {
                            template: '<view-user-in-account-component/>',
                        },
                    },
                    bodyClass: 'page--admin-accounts',
                });

        });

})(angular.module('rocket.components'));
